import { createContext } from 'react';

interface ProgressIndicator {
    current: number;
    max: number;
    percentage: number;
    isAtLimit: boolean;
    isNearLimit: boolean; // 80% of limit
}

export interface UserProgressContextType {
    // Progress indicators
    strategyProgress: ProgressIndicator;
    backtestProgress: ProgressIndicator;

    // Actions
    incrementStrategyCount: () => void;
    incrementBacktestCount: () => void;

    // Status helpers
    hasActiveUsage: boolean;
    isApproachingLimits: boolean;
}

export const UserProgressContext = createContext<UserProgressContextType | undefined>(undefined);
